import { useLabelsContext } from "../../context/LabelsContext";
import "../../styles/AuthSuccess.scss";
import "../../styles/NavButtons.scss";
import { useUserContext } from "../../context/UserContext";
import { useClubContext } from "../../context/ClubContext";
import { JSX, useMemo } from "react";
import { CRM_TYPES } from "../../models/crm-types";
import { useConfigContext } from "../../context/ConfigContext";
import successGif from "../../assets/success.gif";

type AuthSuccessProps = {
	setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AuthSuccess: React.FC<AuthSuccessProps> = ({ setIsModalOpen }) => {
	const { authMode } = useConfigContext();
	const { labels } = useLabelsContext();
	const { user } = useUserContext();
	const { personalAreaUrl } = useClubContext();
	const { club } = useClubContext();

	const header = useMemo((): JSX.Element | undefined => {
		if (user && user.Name && user.LoggedIn) {
			const label: string =
				authMode === "login"
					? (labels?.["CM_LoginSuccess"] ?? "")
					: (labels?.["CM_RegistrationSuccess"] ?? "");

			const headerElements: string[] | null =
				label?.split("<br/>") || null;
			const headerTitle: string =
				headerElements && headerElements.length
					? headerElements[0]
					: "";
			const headerText: string =
				headerElements && headerElements.length > 1
					? headerElements[1]
					: "";
			const memberName: string =
				authMode === "login" ? `, ${user.Name}` : `${user.Name},`;

			return (
				<div className='greetings'>
					<span className='greetings-title'>
						{headerTitle?.replace("{0}", memberName)}
					</span>
					<span className='greetings-text'>{headerText}</span>
				</div>
			);
		}
	}, [labels, user]);

	return (
		<div className='auth-success'>
			{
				<img
					className='success-animation'
					src={successGif}
				/>
			}
			{header}
			<div className='nav-buttons'>
				{club?.cRMType !== CRM_TYPES.OCTOPUS && (
					<a
						href={personalAreaUrl}
						className='nav-button nav-button-secondary'
					>
						{labels?.["ToPrivateArea"]}
					</a>
				)}
				<a
					href={club?.homeSiteUrl}
					className='nav-button nav-button-primary'
				>
					{labels?.["ReturnToSite"]}
				</a>
			</div>
		</div>
	);
};
